/* eslint-disable max-len */
// #region Actions
const actions = {
  async createExample({_commit, _dispatch, _state}, {_token}) {
    return;
  },
};
// #endregion

// #region Getters
const getters = {
  getListUnidades: (state) => state.unidades,
  getUnidad: (state) => (_key) => {
    return state.unidades.find((unidad) => unidad.id === _key);
  },
};
// #endregion

// #region Mutations
const mutations = {
  setListUnidades(stateTarget, unidades) {
    stateTarget.unidades = unidades;
  },
};
// #endregion

// #regionstateTarget
const stateUnidades = () => {
  return {
    unidades: [],
  };
};
// #endregion

// #region Etc
const namespaced = true;
const modules = [];
// #endregion

export default {
  actions,
  getters,
  modules,
  mutations,
  namespaced,
  stateUnidades,
};
